var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16667 12.2917C2.9 12.2917 1.875 11.2667 1.875 10C1.875 8.73333 2.9 7.70833 4.16667 7.70833C5.43333 7.70833 6.45833 8.73333 6.45833 10C6.45833 11.2667 5.43333 12.2917 4.16667 12.2917ZM4.16667 8.95833C3.59167 8.95833 3.125 9.425 3.125 10C3.125 10.575 3.59167 11.0417 4.16667 11.0417C4.74167 11.0417 5.20833 10.575 5.20833 10C5.20833 9.425 4.74167 8.95833 4.16667 8.95833Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8333 12.2917C14.5667 12.2917 13.5417 11.2667 13.5417 10C13.5417 8.73333 14.5667 7.70833 15.8333 7.70833C17.1 7.70833 18.125 8.73333 18.125 10C18.125 11.2667 17.1 12.2917 15.8333 12.2917ZM15.8333 8.95833C15.2583 8.95833 14.7917 9.425 14.7917 10C14.7917 10.575 15.2583 11.0417 15.8333 11.0417C16.4083 11.0417 16.875 10.575 16.875 10C16.875 9.425 16.4083 8.95833 15.8333 8.95833Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 12.2917C8.73333 12.2917 7.70833 11.2667 7.70833 10C7.70833 8.73333 8.73333 7.70833 10 7.70833C11.2667 7.70833 12.2917 8.73333 12.2917 10C12.2917 11.2667 11.2667 12.2917 10 12.2917ZM10 8.95833C9.425 8.95833 8.95833 9.425 8.95833 10C8.95833 10.575 9.425 11.0417 10 11.0417C10.575 11.0417 11.0417 10.575 11.0417 10C11.0417 9.425 10.575 8.95833 10 8.95833Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more.3f85b0bd093c8b11c13527d6514eec2d.svg";